import { motion } from 'framer-motion'

export const ThinkingBubble = () => {
  return (
    <div className="flex items-start">
      <div className="bg-gray-200 rounded-2xl rounded-bl-none px-4 py-3 mt-3 max-w-[200px] scale-[0.65]">
        <div className="flex gap-1.5 items-center justify-center h-4">
          {[0, 1, 2].map((index) => (
            <motion.div
              key={index}
              className="w-2 h-2 bg-gray-500 rounded-full"
              initial={{ opacity: 0.3 }}
              animate={{
                opacity: [0.3, 1, 0.3],
                scale: [1, 1.2, 1],
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: index * 0.2,
                ease: 'easeInOut',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
